/**
 * Nutrition modal/tab: accordion cards, bold markup, fullscreen images.
 * Inits all [data-nutrition-cards-root] on DOMContentLoaded (defer, after parse).
 */
(function () {
  'use strict';

  function processBoldContent(root) {
    if (!root) return;
    root.querySelectorAll('[data-bold-content]').forEach(function (el) {
      var textContent = el.textContent || el.innerText;
      if (textContent && textContent.indexOf('<b>') !== -1) {
        el.innerHTML = textContent;
      }
    });
  }

  function closeAllCards(root) {
    if (!root) return;
    root.querySelectorAll('.content-card').forEach(function (card) {
      card.classList.remove('active');
      var cc = card.querySelector('.card-content');
      if (cc) cc.style.maxHeight = '0';
    });
  }

  function toggleCard(root, card) {
    if (!root || !card) return;
    var cards = root.querySelectorAll('.content-card');
    var content = card.querySelector('.card-content');
    cards.forEach(function (c) {
      if (c !== card && c.classList.contains('active')) {
        c.classList.remove('active');
        var cc = c.querySelector('.card-content');
        if (cc) cc.style.maxHeight = '0';
      }
    });
    card.classList.toggle('active');
    if (!content) return;
    if (card.classList.contains('active')) {
      content.style.maxHeight = content.scrollHeight + 'px';
      card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    } else {
      content.style.maxHeight = '0';
    }
  }

  function initCards(root) {
    if (!root) return;
    root.querySelectorAll('.content-card').forEach(function (card) {
      var header = card.querySelector('h3');
      if (header) {
        header.addEventListener('click', function (e) {
          e.stopPropagation();
          toggleCard(root, card);
        });
      }
      card.addEventListener('click', function (e) {
        if (e.target === card) toggleCard(root, card);
      });
    });
    processBoldContent(root);
  }

  function initImages(root) {
    if (!root) return;
    root.querySelectorAll('.unique-image').forEach(function (image) {
      image.addEventListener('click', function () {
        var fullscreenOverlay = document.createElement('div');
        fullscreenOverlay.classList.add('fullscreen-overlay');
        var fullscreenImage = document.createElement('img');
        fullscreenImage.src = image.src;
        fullscreenImage.classList.add('fullscreen-image');
        var closeButton = document.createElement('button');
        closeButton.classList.add('fullscreen-close');
        closeButton.innerHTML = '×';
        closeButton.setAttribute('aria-label', 'Close fullscreen image');

        fullscreenOverlay.appendChild(fullscreenImage);
        fullscreenOverlay.appendChild(closeButton);
        document.body.appendChild(fullscreenOverlay);

        function closeViewer() {
          fullscreenOverlay.remove();
        }

        closeButton.addEventListener('click', function (e) {
          e.stopPropagation();
          closeViewer();
        });

        fullscreenOverlay.addEventListener('click', function (e) {
          if (e.target === fullscreenOverlay) closeViewer();
        });

        function handleKeyDown(e) {
          if (e.key === 'Escape') {
            closeViewer();
            document.removeEventListener('keydown', handleKeyDown);
          }
        }
        document.addEventListener('keydown', handleKeyDown);
      });
    });
  }

  function initNutritionCards(root) {
    if (!root || root.getAttribute('data-nm-cards-initialized') === 'true') return;
    root.setAttribute('data-nm-cards-initialized', 'true');
    initCards(root);
    initImages(root);
  }

  function openFirstCard(root) {
    if (!root) return;
    var firstCard = root.querySelector('.content-card');
    if (firstCard) toggleCard(root, firstCard);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-nutrition-cards-root]').forEach(initNutritionCards);
  });

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target.closest || !e.target.closest('.js-tabs-opener')) return;
      setTimeout(function () {
        document.querySelectorAll('[data-nutrition-cards-root] .content-card.active .card-content').forEach(function (cc) {
          cc.style.maxHeight = cc.scrollHeight + 'px';
        });
      }, 80);
    },
    true
  );

  window.NutritionCards = {
    init: initNutritionCards,
    processBoldContent: processBoldContent,
    closeAllCards: closeAllCards,
    openFirstCard: openFirstCard,
    toggleCard: toggleCard,
  };
})();
